import React from 'react'
import style from './OilRecordEcoCEO.module.css'
import { OilRecordIcon } from '../../../assets/icons'
import { Translate } from '../../../language'
import TitleSVG from '../../../utils/components/TitleSVG/TitleSVG'
import Input from '../../../utils/components/Input/Input';
import OilRecordItem from './OilRecordItemEcoCEO'
import OilRecordList from './OilRecordListEcoCEO'

const OilRecord = ({ oilRecords, skipReceivedOil, setSkipReceivedOil, limitReceivedOil, setUserEmail }) => {
    const idTimeOuts = [];

    const onSearchValueChange = (e) => {
        let value = e.target.value;

        if (idTimeOuts.length ===0) {
            idTimeOuts.push(setTimeout(() => { searchUser(value) }, 1000));
        }

        else {
            clearTimeout(idTimeOuts[0]);
            idTimeOuts.shift();
            idTimeOuts.push(setTimeout(() => { searchUser(value) }, 1000));
        }
    }

    const searchUser = (value) => {
        setUserEmail(value);
        clearTimeout(idTimeOuts[0]);
        idTimeOuts.length = 0;
    }

    const scrollPagination = (e) => {
        if (e.target.scrollTop + 1 >= e.target.scrollHeight - e.target.clientHeight) {
            setSkipReceivedOil(skipReceivedOil + limitReceivedOil);
        }
    }

    return (
        <div>
            <div className={style.record_container}>
                <TitleSVG Icon={OilRecordIcon}
                    titleHighlight={Translate('oilRecordTitleHighlight', 'es')}
                    title={Translate('oilRecordTitle', 'es')} />

                <div className={style.form_content}>
                    <label htmlFor="email">{Translate('oilMailForm', 'es')}</label>

                    <Input
                        type="email"
                        placeholder={Translate('email', 'es')}
                        name="email"
                        classNameInput={style.form_input}
                        onChange={onSearchValueChange}
                    />
                </div>

                <div className={style.record_grid_container}>
                    <div className={style.record_grid} onScroll={scrollPagination}>
                        <div className={style.record_grid_title}>{Translate('user', 'es')}</div>
                        <div className={style.record_grid_title}>{Translate('date', 'es')}</div>
                        <div className={style.record_grid_title}>{Translate('quantity', 'es')}</div>
                        <div className={style.record_grid_title}>{Translate('ecoPoints', 'es')}</div>

                        <OilRecordList>
                            {oilRecords?.map(record => (
                                <OilRecordItem
                                    key={record.id}
                                    user={record.user}
                                    date={record.date}
                                    quantity={record.quantity}
                                    ecopoints={record.ecopoints}
                                />
                            ))}
                        </OilRecordList>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default OilRecord